import React, { useMemo } from "react"

import SearchInputV2 from "../../../SearchInputV2/SearchInputV2"
import RadioGroup from "../../../RadioGroup/RadioGroup"
import PaymentTerms from "./PaymentTerms"
import usePaymentTerms from "./usePaymentDetails"
import { FormPageProps } from "../.."

import error_mark from "../../../../assets/images/error_mark.svg"
import "../../RaiseTicketFormBeta.scss"

const PaymentDetails = ({ handleNextStep, handleCloseForm, isLastStep, redirectPage }: FormPageProps) => {
    const { states, functions } = usePaymentTerms({ handleNextStep, redirectPage })

    const showPaymentTerms = useMemo(() => {
        let condition = states.paymentTermsFormik.values.specify_payment_terms?.title === "Yes"
        return condition
    }, [states.paymentTermsFormik.values.specify_payment_terms?.title])

    const showError = states.paymentTermsFormik.submitCount > 0

    return (
        <>
            <div className="d-flex gap-28">
                <div className="flex-1">
                    <div className="section_header">Total amount to be received with GST (in ₹)*</div>
                    <div>
                        <SearchInputV2
                            fontsize="12px"
                            placeholder={"Enter Amount"}
                            searchIcon={false}
                            onSearch={(value: string) => {
                                states.paymentTermsFormik.setFieldValue("total_amount", value)
                                functions.saveFormValuesToRedux(value, "total_amount")
                            }}
                            value={states.paymentTermsFormik.values.total_amount}
                            type="number"
                            height="44px"
                            showError={showError}
                            error={Boolean(states.paymentTermsFormik.errors.total_amount)}
                            // disabled={freezeField("total_amount")}
                        />
                    </div>
                </div>
                <div className="flex-1">
                    <div className="section_header">
                        Specify payment terms (by agreement) ?*{" "}
                        {showError && Boolean(states.paymentTermsFormik.errors.specify_payment_terms?.title) && (
                            <img src={error_mark} alt="" />
                        )}
                    </div>
                    <div>
                        <RadioGroup
                            options={[
                                { id: 1, title: "Yes" },
                                { id: 0, title: "No" },
                            ]}
                            onSelect={(value: any) => {
                                states.paymentTermsFormik.setFieldValue("specify_payment_terms", value)
                                functions.saveFormValuesToRedux(value, "specify_payment_terms")
                            }}
                            value={states.paymentTermsFormik.values.specify_payment_terms}
                            // disabled={freezeField("specify_payment_terms")}
                        />
                    </div>
                </div>
            </div>
            {showPaymentTerms && <PaymentTerms states={states} />}
            <footer className="raise-ticket-form__footer">
                <button className="raise-ticket-form__footer-button cancel-btn" onClick={handleCloseForm}>
                    Cancel
                </button>
                <button
                    className="raise-ticket-form__footer-button next-btn"
                    disabled={states.isRaisingSoloLogistics || states.isAddingPaymentTerms}
                    type="button"
                    onClick={() => states.paymentTermsFormik.handleSubmit()}>
                    {isLastStep ? "Submit" : "Next"}
                </button>
            </footer>
        </>
    )
}

export default PaymentDetails
